import { ArticleHeading3, Button, RadioGroup } from '@cian/ui-kit';
import * as styles from './styles.css';
import { TQuiz } from 'shared/types/quiz';

interface IQuizProps {
  onChangeSelectedAnswer: (id: number) => void;
  onBtnQuiz: () => void;
  selectedAnswer?: number;
  quizItem: TQuiz;
}

export const Quiz: React.FC<IQuizProps> = ({ onChangeSelectedAnswer, onBtnQuiz, selectedAnswer, quizItem }) => {
  const { question, answers } = quizItem;

  return (
    <div className={styles['container']}>
      <ArticleHeading3>{question}</ArticleHeading3>
      <div>
        <RadioGroup
          onChange={e => onChangeSelectedAnswer(Number(e.currentTarget.value))}
          value={selectedAnswer}
          options={answers.map(({ id, text }) => ({ label: text, value: id }))}
        />
      </div>
      <Button fullWidth disabled={selectedAnswer === undefined} onClick={onBtnQuiz}>
        Далее
      </Button>
    </div>
  );
};
